export function cashDiscount (percentage, quantity, cost) {
	const rate = percentage / 100

	const discounted_unit_price = parseFloat((cost / (1 + rate)).toFixed(2));

	return {
		discount_amount: ((cost - discounted_unit_price) * quantity).toFixed(2),
		discounted_unit_price
	}
}
